/* eslint-disable */
import Vue from 'vue'
import Rx from 'rxjs/Rx'
import VueRx from 'vue-rx'
Vue.use(VueRx, Rx)
import axios from 'axios'

/**
 * post data to direct express facade 
 * in json format. 
 * from express facade to mysql backend 
 * the request's content-type will be changed into 
 * application/x-www-form-urlencoded 
 * and the Json object sringified and saved under 
 * the '_x' attribute in the request to 
 * come around IE 11 bug
 */
const defaultPOSTHeader = {
  common: {
    'Content-Type': 'application/json;charset=utf-8',
    'Origin': 'https://localhost:8080'
  }
}
const defaultGETHeader = {
  common: {
    'Origin': 'https://localhost:8080'
  }
}

/**
 * - params must be passed as object literals
 * - headers must be passed in the format
 *    {
 *        'Authorization': 'Bearer 5r67nr67r67r67n'
 *    }
 * 
 * @param {*} url 
 * @param {*} headers 
 * @param {*} params 
 */
export const post = (url, params, headers) => {
  params = (! params) ? {} : params
  delete params.router
  axios.defaults.headers.common = defaultPOSTHeader
  if (headers) {
    for (let h in headers) {
      axios.defaults.headers.common[h] = headers[h]
    }
	}
  const cookieNames = Vue.$cookies.keys();
  const allcookies = cookieNames.map(cookieName => `${cookieName}=${Vue.$cookies.get(cookieName)}`).join('; ');
  //axios.defaults.headers.common['Cookie'] = cookieNames
  // axios.defaults.headers.common['Cookie-Data'] = 'cookieName=cookieValue; anotherCookie=anotherValue'
  axios.defaults.headers.common['Cookie-Data'] = allcookies;

  const crypto = require('crypto');
  let mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
  let hashedstr = mykey.update(JSON.stringify(params), 'utf8', 'hex')
  hashedstr += mykey.final('hex');
  // console.log("hello=====hashedstrhashedstrhashedstrhashedstrhashedstr========>", hashedstr)

  return Rx.Observable.fromPromise(
    axios.post(url, params)
  )

}


/**
 * - params must be passed as object literals
 * - headers must be passed in the format
 *    {
 *        'Authorization': 'Bearer 5r67nr67r67r67n'
 *    }
 * 
 * @param {*} url 
 * @param {*} headers 
 * @param {*} params 
 */
export const get = (url, headers, params) => {
  params = (! params) ? {} : params
  // set default headers
  axios.defaults.headers.common = defaultGETHeader  
  if (headers) {
    for (let h in headers) {
      // add extra headers
      axios.defaults.headers.common[h] = headers[h]
    }
  }
  return Rx.Observable.fromPromise(
    axios.get(url,
      {
        data: params
      }
    )
  )
}

/**
 * load json resource from local or remote url
 * @param {*} url 
 * @param {*} headers 
 * @param {*} params 
 */
export const getJson = (url, headers, params) => {
  params = (! params) ? {} : params
  // set default headers
  axios.defaults.headers.common = defaultGETHeader  
  if (headers) {
    for (let h in headers) {
      // add extra headers
      axios.defaults.headers.common[h] = headers[h]
    }
  }
  return Rx.Observable.fromPromise(
    axios.get(url,
      {
        data: params
      }
    )
  )
}



// WEBPACK FOOTER //
// ./src/store/api/rx-factory.js